import React, { Fragment, ReactElement, useEffect, useState } from 'react';

import { Box, IconButton, Typography, Backdrop, CircularProgress, Button, Grid2 } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { WarehouseClient } from '../../api/Extensions';
import { ProjectDto } from '../../api/ClientApi';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import EditIcon from '@mui/icons-material/Edit';
import ProjectForm from './form/ProjectForm';
import { useAppSelector } from '../../hooks/hooks';
import { RootState } from '../../redux/reducers';
import { DetailsContainerBox } from '../../common/ResponsiveStyle';
import { canManipulateProjects } from '../../redux/selectors/employeeSelector';
import SiteForm from '../sites/Form/SiteForm/SiteForm';
import GoodsList from '../goods/GoodsList';
import ProjectInfo from './ProjectInfo';
import SitesList from '../sites/SitesList';

export default function ProjectDetails(): ReactElement {
    const canChangeProjects = useAppSelector(canManipulateProjects);

    const [project, setProject] = useState<ProjectDto | undefined>(undefined);
    const [openUpdateProjectForm, setOpenUpdateProjectForm] = useState<boolean>(false);

    const [openSiteForm, setOpenSiteForm] = useState<boolean>(false);

    const handleCloseSiteForm = () => {
        setOpenSiteForm(false);
    };

    const projects = useAppSelector((state: RootState) => state.projects.projects);

    const navigate = useNavigate();

    const params = useParams();

    useEffect(() => {
        const projectId = params.projectId;
        if (!!projectId && !isNaN(+projectId) && +projectId > 0) {
            WarehouseClient.getProjectById(+projectId, true, true, true).then((res) => {
                setProject(res);
            });
        }
    }, [params, projects]);

    const handleOpenProjectForm = () => {
        setOpenUpdateProjectForm(true);
    };

    const handleCloseProjectForm = () => {
        setOpenUpdateProjectForm(false);
    };

    const handleClose = () => {
        navigate('..');
    };

    return (
        <DetailsContainerBox
            sx={{
                p: 2,
                backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'white' : theme.palette.grey[900]),
            }}
        >
            <Grid2
                container
                sx={{
                    py: 2,
                    px: 4,
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Grid2>
                    <Box sx={{ display: 'flex' }}>
                        <IconButton color="inherit" onClick={handleClose} sx={{ p: 0 }}>
                            <ArrowBackIosIcon />
                        </IconButton>
                        <Typography variant="h5" component="h6">
                            Projekat - detalji
                        </Typography>
                    </Box>
                </Grid2>

                <Grid2 sx={{ display: 'flex', gap: 2 }}>
                    <Grid2 container sx={{ gap: 1 }}>
                        {!!project && canChangeProjects && (
                            <Grid2>
                                <Button
                                    color="warning"
                                    variant="contained"
                                    onClick={handleOpenProjectForm}
                                    startIcon={<EditIcon />}
                                    sx={{ textTransform: 'none' }}
                                >
                                    Izmeni projekat
                                </Button>
                            </Grid2>
                        )}
                    </Grid2>
                </Grid2>
            </Grid2>
            <Box>
                <ProjectInfo project={project} />
            </Box>
            <Box sx={{ '& > :not(style)': { m: 1 } }}>
                {!project?.sites ? (
                    <Fragment>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={!Boolean(project)}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Fragment>
                ) : (
                    <SitesList />
                )}
            </Box>
            <Box sx={{ '& > :not(style)': { m: 1 } }}>
                {!project ? (
                    <Fragment>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={!Boolean(project)}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Fragment>
                ) : (
                    <GoodsList />
                )}
            </Box>
            <SiteForm open={openSiteForm} closeForm={handleCloseSiteForm} />
            {canChangeProjects && <ProjectForm open={openUpdateProjectForm} closeForm={handleCloseProjectForm} />}
        </DetailsContainerBox>
    );
}
